<template>
  <el-row class="page">
    <div class="content-warpper" style="min-height: 840px;box-sizing: border-box;">
      <div class="input-wraper" style="width: 100%;">
        <span>变更时间</span>&nbsp;
        <el-date-picker
          v-model="historyDate"
          value-format="yyyy-MM-dd"
          size="small"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          range-separator="~"
          :picker-options="pickerOptions"
          @change="queryData"
        ></el-date-picker>
        <el-button type="text" @click="downList" style="float: right;" v-if="modalInfo.modulename != 'DEALER'">下载变更历史</el-button>
      </div>
      <div class="history-wrap"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading">
        <el-timeline>
            <el-timeline-item v-for="(item,i) in changeHistoryList" :key="i" :timestamp="item.changetime|fullTime" placement="top">
                <p class="title">变更人：{{item.realname}}</p>
                <el-card>
                    <div class="list">
                      <p>
                        <span :class="item.changeMessage=='设置表格'?'set':item.changeMessage=='删除'?'del':'modifi'" v-if="item.changetype !=2">{{item.changeMessage}}</span>
                      </p>
                      <p v-if="item.contentBefore && item.changetype == 2">
                        <span class="before">变更前</span>
                        {{item.contentBefore}}
                      </p>
                      <p v-if="item.contentBefore && item.changetype != 2">
                        {{item.contentBefore}}
                      </p>
                      <p v-if="item.contentAfter && item.changetype == 2">
                        <span class="after">变更后</span>
                        {{item.contentAfter}}
                      </p>
                      <p v-if="item.contentAfter && item.changetype != 2">
                        {{item.contentAfter}}
                      </p>
                    </div>
                </el-card>
            </el-timeline-item>
        </el-timeline>
        <el-button size="small" class="btnMore" v-if="moreBtnShow" @click="moreLoad">加载更多...</el-button>
        <div class="nodata" v-if="changeHistoryList.length == 0"><img src="../../../assets/img/other/nodata.svg">暂无数据</div>
      </div>
    </div>
  </el-row>
</template>
<script>
import {fetchGet} from "@/libs/reqCommon";
export default {
  props: {
    modalInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      historyDate: [],
      changeHistoryList:[],
      // 配置最近三个月
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit('pick', [start, start]);
            }
          },{
            text: '近7日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '近15日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: '近30日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: "近90日",
            onClick: picker => {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '近365日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      moreBtnShow:false,
      query:{
        pageNum :1,
        pageSize:10
      },
      pageId:"",
    };
  },
  created() {
  },
  methods: {
    // 变更历史请求
    reqChangeHistory(id){
      console.log(id)
      this.pageId = id;
      let query = {
  		  ...this.query,
  		  modulename:this.modalInfo.modulename,
        objectid:id,
      }
      if (id === null) {
        query.isall = '1'
      } else {
        query.isall = ''
      }
      this.reqChangeHistoryData(query);
    },
    downList() {
      let query = {
  		  ...this.query,
  		  modulename:this.modalInfo.modulename,
        objectid:this.pageId,
      }
      if (this.historyDate.length != 0) {
        query.begintime = this.historyDate[0]
        query.endtime = this.historyDate[1]
      }
      if (this.pageId === null) {
        query.isall = '1'
      } else {
        query.isall = ''
      }
      fetch({
        url: "hcm/hcmChangeHistory/downList",
        method: "post",
        data: query,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 5
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", '变更历史.xlsx');
        document.body.appendChild(link);
        link.click();
        this.lowPriceLoading = false
      });
    },
    reqChangeHistoryData(query){
      this.loading = true
      fetchGet("/hcm/hcmChangeHistory/getList",query).then(res =>{
        if(res.status == "10000"){
          this.loading = false
          this.changeHistoryList = res.data;
          if(res.data.length<this.query.pageSize)
          this.moreBtnShow = false;
          else this.moreBtnShow = true;
        }
      });
    },
    // 根据时间查询
    queryData(date){
      let query = {
		    ...this.query,
        modulename:this.modalInfo.modulename,
        objectid:this.pageId,
        begintime:date[0],
        endtime:date[1],
      }
      console.log(!this.pageId)
      if (!this.pageId) {
        query.isall = '1'
      } else {
        query.isall = ''
      }
      this.reqChangeHistoryData(query);
    },
    // 加载更多
    moreLoad(){
      this.query.pageSize = this.query.pageSize+10
      this.reqChangeHistory(this.pageId);
    }
  }
};
</script>
<style lang="scss" scoped>

</style>
